module.exports = __webpack_public_path__ + "static/media/reciclables-02.98092073.png";